import {AxiosError} from 'axios';
import {GET_NOTIFICATION_ACKNOWLEDGEMENT_STATUS_QUERY_KEY} from 'web-library/constants/queryKeys';
import {GET_NOTIFICATION_ACKNOWLEDGEMENT_STATUS_URL} from 'web-library/constants/apiUrls';
import {useCustomQuery} from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

interface NotificationAcknowledgementStatusResponse {
  acknowledged: boolean;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: NotificationAcknowledgementStatusResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const useGetNotificationAcknowledgementStatus = ({onSuccess, onError, uuid}: Input) => {
  const getNotificationAcknowledgementStatus = async () => {
    const res = await axiosClient.get<NotificationAcknowledgementStatusResponse>(
        GET_NOTIFICATION_ACKNOWLEDGEMENT_STATUS_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
      [GET_NOTIFICATION_ACKNOWLEDGEMENT_STATUS_QUERY_KEY, uuid],
      getNotificationAcknowledgementStatus,
      {
        onSuccess,
        onError,
      },
      false,
      false
  );
};
